import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import * as ProductoCrud from 'services/producto.service'

const CodigoFormGroup = ({ iError, iTouched, fIsSubmitting, values, setValues, handleChange }) => {
  const [generandoCodigo, setGenerandoCodigo] = React.useState(false)

  const generarCodigoClickHandler = React.useCallback(() => {
    setGenerandoCodigo(true)
    ProductoCrud.getNuevoCodigo().then(({ data }) => {
      setGenerandoCodigo(false)
      values.codigo = data.nuevoCodigo
      values.codigoGeneradoFlag = true
      setValues(values)
    })
  }, [values, setValues])

  return (
    <Form.Group>
      <Form.Label text='CÓDIGO' htmlFor='input-codigo' xs={3} alignRightAt='xs' />
      <Col xs={9}>
        <Form.InputGroup>
          <Field name='codigo'>
            {({ field }) => (
              <Form.InputText
                {...field}
                id='input-codigo'
                isInvalid={iTouched && iError}
                onChange={e => {
                  handleChange(e)
                  values.codigo = e.target.value
                  values.codigoGeneradoFlag = false
                  setValues(values)
                }}
              />
            )}
          </Field>
          <Form.InputGroup.Append>
            <Button
              disabled={fIsSubmitting || generandoCodigo}
              color='secondary'
              outline
              onClick={generarCodigoClickHandler}
            >
              Generar
            </Button>
          </Form.InputGroup.Append>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Form.InputGroup>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
